<template>
  <v-dialog v-model="showModal" :max-width="'40%'" @keydown.esc="cancel">
    <v-card>
      <v-toolbar dark :color="'primary-main lighten-'" dense flat>
        <v-toolbar-title class="text-body-2 font-weight-bold text-white">
          What area do you work in?
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text class="flex pa-4 black--text">
        <v-radio-group v-model="affiliation" column>
          <v-radio
            v-for="(item, index) in affiliations"
            :key="index"
            :label="item.title"
            color="primary-main"
            :value="item.title"
          ></v-radio>
        </v-radio-group>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!--<v-btn
          variant="flat"
          class="!py-3 !bg-primary-danger !text-white mr-4 mb-1 !rounded-xl !tracking-normal !capitalize !h-auto min-w-[120px]"
          @click.stop="cancel"
        >
          Close
        </v-btn>-->
        
        <v-btn
          @click="updateProfile"
          :loading="loadingResponse"
          variant="flat"
          class="!py-3 !bg-primary-main !rounded-xl !tracking-normal !capitalize !text-white !h-auto min-w-[120px]"
        >
          Save
          <v-tooltip v-if="!affiliation" activator="parent" location="top"
            >Please answer the survey</v-tooltip
          >
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
import { Vue } from 'vue-class-component';
import { Watch, Prop } from 'vue-property-decorator';
import { usePayloadStore } from '@/stores/payload';
import { getProfile, updateProfile } from '@/actions/auth';
import Message from 'antd-message';
import { Affiliations } from '@/utils/configs';

export default class Affiliation extends Vue {
  mounted() {
    const check = this.affiliations
      .map((affiliation: any) => affiliation.title)
      .includes(this.payloadStore.payload.affiliation);
    const checkEs = this.affiliationsEs
      .map((affiliation: any) => affiliation.title)
      .includes(this.payloadStore.payload.affiliation);
    if (!(check || checkEs) && !this.isDemoAccount) this.getProfile();
  }

  public modal: boolean = false;

  private payloadStore = usePayloadStore();

  public loadingResponse = false;

  public affiliation = '';

  public user = {};

  get showModal() {
    return this.modal;
  }

  set showModal(newValue) {
    this.$emit('update:modelValue', newValue);
  }

  get isDemoAccount() {
    return (
      this.payloadStore.payload.user.username === 'WriteWise_Demo' ||
      this.payloadStore.payload.user.username === 'contact@writewise.io'
    );
  }

  public affiliations = Affiliations.en;
  public affiliationsEs = Affiliations.es;

  public selectedIndex: number = 0;

  public cancel() {
    this.modal = false;
  }

  private getProfile = () => {
    getProfile(this.payloadStore.payload.user.pk)
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then((res: any) => {
        this.user = res.user;
        const check = this.affiliations
          .map((affiliation: any) => affiliation.title)
          .includes(res.affiliation);
        const checkEs = this.affiliationsEs
          .map((affiliation: any) => affiliation.title)
          .includes(res.affiliation);
        if (!(check || checkEs)) {
          this.payloadStore.change({ affiliation: res.affiliation });
          this.modal = true;
        }
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((err) => {});
  };

  public updateProfile = () => {
    if (!this.affiliation || this.isDemoAccount || this.loadingResponse) {
      return;
    }
    this.loadingResponse = true;
    updateProfile(this.payloadStore.payload.user.pk, {
      user: this.user,
      affiliation: this.affiliation
    })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .then((res: any) => {
        this.loadingResponse = false;
        Message.success("User's affiliation updated successfully");
        this.modal = false;
      })
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      .catch((err) => {
        this.loadingResponse = false;
        Message.error("User's affiliation could not be updated");
      });
  };
}
</script>
